const state = {
  assetUrlList: null
}

const getters = {
}

const mutations = {
  SET_ASSET_URL_LIST (state, payload) {
    state.assetUrlList = payload
  }
}

const actions = {
}

export default { state, getters, mutations, actions }
